import * as React from 'react';
import styled from 'styled-components';

import DropDownView from './views/DropDownView';
import Field from './Field';
import Rooms from './Rooms';
import { IRoom, ILabel, ISnowSearchPlacement } from './types';
import { SNOW_SEARCH_FIELD_FOCUSED } from './events';
import { countPeople, defaultRooms } from './helpers';
import t from './locales';

const FieldPeopleView = styled.div`
  position: relative;
`;

interface IProps {
  placement: ISnowSearchPlacement;
  isDropDownShown: boolean;
  rooms: IRoom[]
  setRooms: Function;
}

const FieldRooms: React.FC<IProps> = (props) => {
  const { placement, isDropDownShown, rooms, setRooms } = props;

  function handleClick(): void {
    if (rooms.length === 0) { setRooms(defaultRooms); }
    const detail = { focusedField: 'rooms', placement };
    const clickEvent = new CustomEvent(SNOW_SEARCH_FIELD_FOCUSED, { detail });
    document.dispatchEvent(clickEvent);
  }

  function fieldLabel(): ILabel {
    const label = { main: '', sub: '' };
    if (rooms.length === 0) { return label; }
    label.sub = t.roomCount({ count: rooms.length });
    const count = countPeople(rooms);
    label.main = `${t.adults()} ${count.adultCount}・${t.children()} ${count.childCount}}`;
    return label;
  }

  return (
    <FieldPeopleView>
      <Field
        icon="people"
        placeholder={t.numberOfGuests()}
        label={fieldLabel()}
        handleClick={handleClick} />
      {isDropDownShown &&
        <DropDownView>
          <Rooms rooms={rooms} setRooms={setRooms} />
        </DropDownView>}
    </FieldPeopleView>
  );
}

export default FieldRooms;
